/**
 * @generated SignedSource<<5b9e7404258a533a7a892b9fc761e454>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NotificationChannel = "EMAIL" | "PUSH" | "SMS";
export type useNotificationsUpdateModalDataQuery$variables = Record<PropertyKey, never>;
export type useNotificationsUpdateModalDataQuery$data = {
  readonly session: {
    readonly user: {
      readonly email?: string | null | undefined;
      readonly id: string;
      readonly isEmailVerified?: boolean | null | undefined;
      readonly isPhoneVerified?: boolean | null | undefined;
      readonly notificationPreferencesChannels?: {
        readonly bookingReminders: ReadonlyArray<NotificationChannel | null | undefined>;
        readonly bookingUpdates: ReadonlyArray<NotificationChannel | null | undefined>;
        readonly eventReminders: ReadonlyArray<NotificationChannel | null | undefined>;
        readonly eventUpdates: ReadonlyArray<NotificationChannel | null | undefined>;
        readonly requestedTimeAvailable: ReadonlyArray<NotificationChannel | null | undefined>;
      };
      readonly phoneNumber?: {
        readonly formattedNumber: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useNotificationsUpdateModalDataQuery = {
  response: useNotificationsUpdateModalDataQuery$data;
  variables: useNotificationsUpdateModalDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEmailVerified",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPhoneVerified",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "INTERNATIONAL"
    }
  ],
  "kind": "ScalarField",
  "name": "formattedNumber",
  "storageKey": "formattedNumber(format:\"INTERNATIONAL\")"
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "NotificationPreferencesChannels",
  "kind": "LinkedField",
  "name": "notificationPreferencesChannels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookingUpdates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookingReminders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventUpdates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventReminders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestedTimeAvailable",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useNotificationsUpdateModalDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhoneNumber",
                    "kind": "LinkedField",
                    "name": "phoneNumber",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useNotificationsUpdateModalDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhoneNumber",
                    "kind": "LinkedField",
                    "name": "phoneNumber",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a9625caef1e6faea0ddbb9092e46845b",
    "id": null,
    "metadata": {},
    "name": "useNotificationsUpdateModalDataQuery",
    "operationKind": "query",
    "text": "query useNotificationsUpdateModalDataQuery {\n  session {\n    user {\n      __typename\n      id\n      ... on MemberUser {\n        email\n        isEmailVerified\n        isPhoneVerified\n        phoneNumber {\n          formattedNumber(format: INTERNATIONAL)\n          id\n        }\n        notificationPreferencesChannels {\n          bookingUpdates\n          bookingReminders\n          eventUpdates\n          eventReminders\n          requestedTimeAvailable\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cba7e64868a653d457c449450330ae5e";

export default node;
